import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import CaseSummaryControls from "./CaseSummaryControls"
import CaseSummaryDetails from "./CaseSummaryDetails"

const CaseSummaryTab = ({ inWorkQ }) => {
    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Case Summary</h2>
                <NotesComponent noteTypeId={13} inWorkQ={inWorkQ}/>
            </div>
            <CaseSummaryControls />
        </TabHeader>

        <CaseSummaryDetails />
    </>
}

export default CaseSummaryTab